<div #psdkContainer class="smp-photo-editor"></div>
